import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers, withProps } from 'recompose'
import { googleAnalyticPromotionImpressions, googleAnalyticPromotionClicks } from 'actions/googleAnalytic'
import withType from 'components/common/hoc/withType'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import { getPageLocation } from 'selectors'
import ScrollablePromotionBannerSpotlight from './ScrollablePromotionBannerSpotlight'
import { PROMO_CALL } from 'constant'
import { isItResourcesPage } from './helpers'

const mapStateToProps = state => {
  const pageLocation = getPageLocation(state)

  return {
    isResourcesPage: isItResourcesPage(pageLocation && pageLocation.pathname)
  }
}

const withSendAnalyticOnDidMount = lifecycle({
  componentDidMount() {
    const { items, googleAnalyticPromotionImpressions } = this.props

    googleAnalyticPromotionImpressions({ items })
  }
})

const withPromotionClickHandler = withHandlers({
  handlePromotionClick: ({ googleAnalyticPromotionClicks }) => ({ event, item, index }) => {
    if (event.target.getAttribute('data-type') === PROMO_CALL) {
      googleAnalyticPromotionClicks({ item, index })
    }
  }
})

export default compose(
  withType({ type: 'ScrollablePromotionBannerSpotlight' }),
  connect(mapStateToProps, { googleAnalyticPromotionImpressions, googleAnalyticPromotionClicks }),
  withSendAnalyticOnDidMount,
  withPromotionClickHandler,
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick
)(ScrollablePromotionBannerSpotlight)
